import { getShopifyShopUrl, selectShopifyPlanAndPay } from '../shopify/shopifyApi';
import type { UserProfile } from '../../../types/auth';

/**
 * The Shopify branch of `NewUserBillingView.handleUpgrade`, pulled out verbatim
 * so the day-15 platform-trial approval dialog calls the exact same path.
 *
 * Picking a credit plan via `selectShopifyPlanAndPay` during an onboarding-3.0
 * platform trial IS the approval (backend `activate()` clears
 * `requiresApproval`) — picking Growth again or switching to Core both count;
 * neither chatbot-api nor ShopifyAPI rejects "same plan".
 *
 * Returns the Shopify confirmation URL; the caller does
 * `window.location.href = url` (this function does not navigate itself, so it
 * can be awaited from a modal before redirecting).
 */
export async function startShopifyPlanApproval(
  user: UserProfile,
  planId: string,
  isYearly: boolean
): Promise<string> {
  const url = getShopifyShopUrl(user);
  if (!url) throw new Error('Shopify shop URL not found');
  const status = user.payment?.paymentStatus || 'unpaid';
  const res = await selectShopifyPlanAndPay(url, planId, isYearly, user.id, user, status);
  if (res.code === 200 && res.data.appSubscriptionCreate.confirmationUrl) {
    return res.data.appSubscriptionCreate.confirmationUrl;
  }
  throw new Error(res.error || 'Failed to initiate Shopify payment');
}
